import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { LoanApiService } from '../../_services/loan-api.service';

@Component({
  selector: 'app-logout',
  imports: [CommonModule],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss',
  standalone: true,
})
export class LogoutComponent implements OnInit {
  constructor(
    private msalService: MsalService,
    private loanApiService: LoanApiService
  ) {}

  ngOnInit(): void {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    if (token) {
      this.loanApiService.logout(token).subscribe({
        next: () => this.finalizeLogout(),
        error: () => this.finalizeLogout(),
      });
    } else {
      this.finalizeLogout();
    }
  }

  private finalizeLogout(): void {
    sessionStorage.removeItem('token');
    localStorage.removeItem('token');
    // Invalidate session in Azure AD as well
    this.msalService.logoutRedirect({
      postLogoutRedirectUri: window.location.origin
    });
  }
}
